import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ArrowDownIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 8",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M6.003 7.21a.826.826 0 0 0 .61-.27l5.159-5.284A.75.75 0 0 0 12 1.11a.78.78 0 0 0-.782-.792.803.803 0 0 0-.568.237L5.672 5.662h.662L1.351.555A.796.796 0 0 0 .782.318.779.779 0 0 0 0 1.11c0 .213.081.396.227.551l5.16 5.28c.183.182.382.27.616.27Z"
  })
});
export default ArrowDownIcon;